<div class="overview-panel" [ngClass]="{'overview-hidden': isOverviewActive}">
    <div class="overview-inner">
        <div class="d-flex justify-content-between align-items-center">
            <h4 class="fw-4 title-text">{{VIEWS}}</h4>
            <button mat-button (click)="close()">{{CLOSE}}</button>
        </div>
        @if (canSaveView()) {
            <h4 class="fw-4 title-text">{{CREATE_NEW_VIEW}}</h4>
            <div class="form-group col-12 d-flex justify-content-center align-items-center">
                <mat-form-field appearance="fill" class="col-12">
                    <input matInput [(ngModel)]="name" [placeholder]="PLACEHOLDER_VIEW_NAME">
                </mat-form-field>
            </div>
            <div class="d-flex justify-content-start align-items-center">
                <button class="mt-2" mat-raised-button (click)="onSave()">{{SAVE_VIEW_BUTTON}}</button>
            </div>
            @if (tabView) {
                <div class="d-flex justify-content-start align-items-center">
                    <button class="mt-2" mat-raised-button (click)="onUpdate()">{{SAVE_IN_VIEW}} {{tabView.file_name}}</button>
                </div>
            }
            <hr class="mt-4 mb-4">
        }

        <div class="d-flex justify-content-between align-items-center">
            <h4 class="fw-4 title-text">{{RESTORE_A_VIEW}}</h4>
            <button mat-button (click)="getViews()">Reload</button>
        </div>
        <div class="views-layout">
            @if (!loadingViews) {
                @for (view of views; track $index) {
                    <div class="view-container justify-content-between align-items-center">
                        <p class="mb-0">
                            {{view.file_name}} [{{getViewServiceName(view)}}]
                        </p>
                        <button mat-icon-button [cdkMenuTriggerFor]="menu" (cdkMenuOpened)="onViewSelected(view)">
                            <mat-icon>more_vert</mat-icon>
                        </button>
                    </div>
                }
            }@else{
                {{LOADING_VIEWS}}
                <mat-progress-bar mode="indeterminate"></mat-progress-bar>
            }
        </div>

        <!-- @if (treeInfo.length) {
            <schema-tree (result)="selectFromTree($event)" [initData]="treeInfo"></schema-tree>
        } -->

        <ng-template #menu>
            <div class="menu" #cdkMenu="cdkMenu" cdkMenu>
                <button class="menu-item" mat-menu-item (click)="onRestore('IMPORT_IN_VIEW', cdkMenu)" [disabled]="!isSameDataService() || !canSaveView()">
                    <span>{{RESTORE_HERE}}</span>
                </button>
                <button class="menu-item" mat-menu-item (click)="onRestore('IMPORT_NEW_TAB', cdkMenu)">
                    <span>{{RESTORE_NEW_TAB}}</span>
                </button>
                <button class="menu-item" mat-menu-item (click)="onDownloadView()">
                    <span>{{EXPORT_VIEW}}</span>
                </button>
                <button class="menu-item" mat-menu-item (click)="deleteFile()">
                    <span color="red">{{DELETE_VIEW}}</span>
                </button>
            </div>
        </ng-template>

        <div class="form-group col-12 d-flex justify-content-center align-items-center">
            <input #input type="file" style="display: none" (change)="onFileSelected($event)">
        </div>
        <div class="d-flex flex-column justify-content-center align-items-start">
            <button class="mt-2" mat-raised-button (click)="onImportView()">{{IMPORT_VIEW}}</button>
            <p class="json-text mt-2">* Import .json File</p>
        </div>
    </div>
</div>
